export const enum DevicePlatform {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export const enum PlatformType {
  IOS = 'ios',
  ANDROID = 'android',
  WEB = 'web',
}

interface IDeviceData {
  deviceType: DevicePlatform;
  platform: PlatformType;
}

export const getDeviceDataFromUserAgent = (userAgent: string): IDeviceData => {
  const agent = userAgent.toLowerCase();
  const isMobileUA = /iphone|ipad|ipod|android/.test(agent);

  if (!isMobileUA) {
    return { deviceType: DevicePlatform.DESKTOP, platform: PlatformType.WEB };
  }

  if (/iphone|ipad|ipod/.test(agent)) {
    return { deviceType: DevicePlatform.MOBILE, platform: PlatformType.IOS };
  }

  return { deviceType: DevicePlatform.MOBILE, platform: PlatformType.ANDROID };
};
